import { useMutation } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

interface GenerateNegotiationAIRequest {
  community_id: number;
  query?: string;
  negotiation_id?: number;
}

interface GenerateNegotiationAIResponse {
  response: string;
}

export const useGenerateNegotiationAI = () => {
  const { session } = useAuth();

  return useMutation<GenerateNegotiationAIResponse, Error, GenerateNegotiationAIRequest>({
    mutationFn: async (data: GenerateNegotiationAIRequest) => {
      const endpoint = `communities/${data.community_id}/negotiation/generate`;
      const requestBody: { query?: string; negotiation_id?: number } = {};

      if (data.query) {
        requestBody.query = data.query;
      }
      if (data.negotiation_id) {
        requestBody.negotiation_id = data.negotiation_id;
      }

      const response = await handleApiCall<
        GenerateNegotiationAIResponse,
        { query?: string; negotiation_id?: number }
      >(session, 'POST', endpoint, requestBody);
      return response;
    },
  });
};
